import { Moment } from "moment";
import { PickersDay, PickersDayProps } from "@mui/x-date-pickers";

import { colors } from "@dotnet/telematics-design-system";

import { useRangePickerStyles } from "./hooks";
import { RangePickerDayProps } from "./types";

const RangePickerDay = ({
    startDate,
    endDate,
    hoveredDay,
    setHoveredDay,
    onRangeDateSelect,
    ...other
}: RangePickerDayProps & PickersDayProps<Moment>) => {
    const { gray100 } = colors;

    const { bgColorTransition, setSpecificStyles } = useRangePickerStyles();

    const { day } = other;

    const isFirstSelected = !!startDate && day.isSame(startDate, "day");
    const isLastSelected = !!endDate && day.isSame(endDate, "day");

    const isMiddleSelected =
        Boolean(startDate) &&
        Boolean(endDate) &&
        day.isAfter(startDate, "day") &&
        day.isBefore(endDate, "day");

    const isInHoverRange =
        Boolean(startDate) &&
        !endDate &&
        Boolean(hoveredDay) &&
        ((day.isAfter(startDate, "day") && day.isBefore(hoveredDay, "day")) ||
            day.isSame(hoveredDay, "day"));

    return (
        <PickersDay
            {...other}
            disableRipple
            disableTouchRipple
            onMouseEnter={() => setHoveredDay?.(day)}
            onMouseLeave={() => setHoveredDay?.(null)}
            onDaySelect={() => onRangeDateSelect?.(day)}
            sx={{
                transition: "none",

                "&:focus": {
                    outline: "none",
                    background: "transparent"
                },

                "&.Mui-focusVisible": {
                    outline: "none",
                    background: "transparent"
                },

                "&:hover": {
                    background: gray100,
                    ...bgColorTransition
                },

                ...setSpecificStyles(
                    isFirstSelected,
                    isLastSelected,
                    isMiddleSelected,
                    isInHoverRange,
                    false
                ),

                "&.MuiPickersDay-today, &.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus":
                    {
                        ...setSpecificStyles(
                            isFirstSelected,
                            isLastSelected,
                            isMiddleSelected,
                            isInHoverRange,
                            true
                        )
                    }
            }}
        />
    );
};

export default RangePickerDay;
